import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import PublicLayout from "@/components/layout/PublicLayout";
import Home from "@/pages/Home";
import Deals from "@/pages/Deals";
import Partners from "@/pages/Partners";
import OfferDetail from "@/pages/OfferDetail";
import BusinessDetail from "@/pages/BusinessDetail";
import Categories from "@/pages/Categories";
import CategoryDetail from "@/pages/CategoryDetail";
import Cities from "@/pages/Cities";
import About from "@/pages/About";
import Guides from "@/pages/Guides";
import GuideArticle from "@/pages/GuideArticle";
import GuidePratique from "@/pages/GuidePratique";
import BecomePartner from "@/pages/BecomePartner";
import PartnerSignup from "@/pages/PartnerSignup";
import FounderOffer from "@/pages/FounderOffer";
import ClubLanding from "@/pages/ClubLanding";
import LandingCSE from "@/pages/LandingCSE";
import ProsLanding from "@/pages/ProsLanding";
import ProReceiveQuotes from "@/pages/ProReceiveQuotes";
import AvisHub from "@/pages/AvisHub";
import AssociationsLanding from "@/pages/AssociationsLanding";
import PolePage from "@/pages/PolePage";
import CityPage from "@/pages/CityPage";
import Login from "@/pages/auth/Login";
import Register from "@/pages/auth/Register";
import GoogleCallback from "@/pages/auth/GoogleCallback";
import WelcomeGoogle from "@/pages/auth/WelcomeGoogle";
import ForgotPassword from "@/pages/auth/ForgotPassword";
import ResetPassword from "@/pages/auth/ResetPassword";
import AccountLayout from "@/pages/account/AccountLayout";
import AiAgent from "@/pages/AiAgent";
import AiAgentStandalone from "@/pages/AiAgentStandalone";
import AccountProfile from "@/pages/account/AccountProfile";
import Favorites from "@/pages/account/Favorites";
import ProLayout from "@/pages/pro/ProLayout";
import ProDashboard from "@/pages/pro/ProDashboard";
import ProStats from "@/pages/pro/ProStats";
import ProBusiness from "@/pages/pro/ProBusiness";
import ProOffers from "@/pages/pro/ProOffers";
import ProNetworkDirectory from "@/pages/pro/ProNetworkDirectory";
import ProNetworkConnections from "@/pages/pro/ProNetworkConnections";
import ProNetworkProfile from "@/pages/pro/ProNetworkProfile";
import ProNetworkListings from "@/pages/pro/ProNetworkListings";
import ProNetworkMessages from "@/pages/pro/ProNetworkMessages";
import NetworkPublic from "@/pages/NetworkPublic";
import NetworkSector from "@/pages/NetworkSector";
import NetworkLayout from "@/pages/network/NetworkLayout";
import ProOfferForm from "@/pages/pro/ProOfferForm";
import ProSubscription from "@/pages/pro/ProSubscription";
import ProFbPosts from "@/pages/pro/ProFbPosts";
import ProHelp from "@/pages/pro/ProHelp";
import ProEventShare from "@/pages/pro/ProEventShare";
import ProBlogShare from "@/pages/pro/ProBlogShare";
import ProPressShare from "@/pages/pro/ProPressShare";
import ProVoisinShare from "@/pages/pro/ProVoisinShare";
import ProInvoices from "@/pages/pro/ProInvoices";
import ProSupport from "@/pages/pro/ProSupport";
import AdminSupport from "@/pages/admin/AdminSupport";
import AdminOfferReports from "@/pages/admin/AdminOfferReports";
import ProScanner from "@/pages/pro/ProScanner";
import ProReviews from "@/pages/pro/ProReviews";
import ProReputation from "@/pages/pro/ProReputation";
import MemberLayout from "@/pages/member/MemberLayout";
import MemberPass from "@/pages/member/MemberPass";
import MemberRewards from "@/pages/member/MemberRewards";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminPros from "@/pages/admin/AdminPros";
import AdminOffers from "@/pages/admin/AdminOffers";
import AdminOfferForm from "@/pages/admin/AdminOfferForm";
import AdminCreatePro from "@/pages/admin/AdminCreatePro";
import AdminCreateOffer from "@/pages/admin/AdminCreateOffer";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminCities from "@/pages/admin/AdminCities";
import AdminRequests from "@/pages/admin/AdminRequests";
import AdminCodes from "@/pages/admin/AdminCodes";
import AdminImportBeneficiaries from "@/pages/admin/AdminImportBeneficiaries";
import AdminJournal from "@/pages/admin/AdminJournal";
import AdminEmailLogs from "@/pages/admin/AdminEmailLogs";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminPartnerSignups from "@/pages/admin/AdminPartnerSignups";
import AdminPartnerConfig from "@/pages/admin/AdminPartnerConfig";
import AdminFacebookGroups from "@/pages/admin/AdminFacebookGroups";
import AdminFbPosts from "@/pages/admin/AdminFbPosts";
import AdminEventShare from "@/pages/admin/AdminEventShare";
import AdminOfferShare from "@/pages/admin/AdminOfferShare";
import AdminSocialReach from "@/pages/admin/AdminSocialReach";
import AdminFbPostShare from "@/pages/admin/AdminFbPostShare";
import AdminSocialStudio from "@/pages/admin/AdminSocialStudio";
import AdminAIStudio from "@/pages/admin/AdminAIStudio";
import AdminOrganizations from "@/pages/admin/AdminOrganizations";
import AdminReviews from "@/pages/admin/AdminReviews";
import AdminPartnerRecommendations from "@/pages/admin/AdminPartnerRecommendations";
import AdminEvents from "@/pages/admin/AdminEvents";
import AdminPushNotifications from "@/pages/admin/AdminPushNotifications";
import AdminClubs from "@/pages/admin/AdminClubs";
import FacebookGroups from "@/pages/FacebookGroups";
import OrganismePresentation from "@/pages/OrganismePresentation";
import OrganismeRegister from "@/pages/OrganismeRegister";
import JoinOrganization from "@/pages/JoinOrganization";
import OrgLayout from "@/pages/org/OrgLayout";
import OrgDashboard from "@/pages/org/OrgDashboard";
import OrgProfile from "@/pages/org/OrgProfile";
import OrgMembers from "@/pages/org/OrgMembers";
import Associations from "@/pages/Associations";
import AssociationDetail from "@/pages/AssociationDetail";
import AssociationRegister from "@/pages/AssociationRegister";
import AssociationNews from "@/pages/AssociationNews";
import AssocLayout from "@/pages/assoc/AssocLayout";
import AssocDashboard from "@/pages/assoc/AssocDashboard";
import AssocDonations from "@/pages/assoc/AssocDonations";
import AssocProfile from "@/pages/assoc/AssocProfile";
import AssocEvents from "@/pages/assoc/AssocEvents";
import AssocNews from "@/pages/assoc/AssocNews";
import AssocMembers from "@/pages/assoc/AssocMembers";
import AssocDocuments from "@/pages/assoc/AssocDocuments";
import AssocResources from "@/pages/assoc/AssocResources";
import JoinAssociation from "@/pages/JoinAssociation";
import AdminAssociations from "@/pages/admin/AdminAssociations";
import Clubs from "@/pages/Clubs";
import ClubDetail from "@/pages/ClubDetail";
import ClubRegister from "@/pages/ClubRegister";
import ClubNewsPublic from "@/pages/ClubNewsPublic";
import JoinClub from "@/pages/JoinClub";
import ClubLayout from "@/pages/clubs/ClubLayout";
import ClubDashboard from "@/pages/clubs/ClubDashboard";
import ClubProfile from "@/pages/clubs/ClubProfile";
import ClubEvents from "@/pages/clubs/ClubEvents";
import ClubNews from "@/pages/clubs/ClubNews";
import ClubMembers from "@/pages/clubs/ClubMembers";
import ClubDonations from "@/pages/clubs/ClubDonations";
import ClubDocuments from "@/pages/clubs/ClubDocuments";
import ClubResources from "@/pages/clubs/ClubResources";
import AdminEspaceClubs from "@/pages/admin/AdminEspaceClubs";
import Contact from "@/pages/Contact";
import Suggestions from "@/pages/Suggestions";
import MapPage from "@/pages/Map";
import RecommendPartner from "@/pages/RecommendPartner";
import AroundMe from "@/pages/AroundMe";
import EventsPage from "@/pages/EventsPage";
import EventDetail from "@/pages/EventDetail";
import AdminFicheReminders from "@/pages/admin/AdminFicheReminders";
import AdminEntityReminders from "@/pages/admin/AdminEntityReminders";
import AdminPartnerFiches from "@/pages/admin/AdminPartnerFiches";
import CategoryCityPage from "@/pages/CategoryCityPage";
import Blog from "@/pages/Blog";
import GoogleListings from "@/pages/GoogleListings";
import BlogArticle from "@/pages/BlogArticle";
import PressReview from "@/pages/PressReview";
import PressTrio from "@/pages/PressTrio";
import PressArticle from "@/pages/PressArticle";
import EntreVoisins from "@/pages/EntreVoisins";
import EntreVoisinsDetail from "@/pages/EntreVoisinsDetail";
import NeighborProfile from "@/pages/NeighborProfile";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminPressReview from "@/pages/admin/AdminPressReview";
import AdminPressReview3Art from "@/pages/admin/AdminPressReview3Art";
import RevuePresseList from "@/pages/RevuePresseList";
import RevuePresse from "@/pages/RevuePresse";
import AdminRevuePresse from "@/pages/admin/AdminRevuePresse";import AdminEntreVoisins from "@/pages/admin/AdminEntreVoisins";
import AdminSiteBuilder from "@/pages/admin/AdminSiteBuilder";
import CmsPage from "@/pages/CmsPage";
import RouteOverride from "@/components/cms/RouteOverride";
import AdminShareStats from "@/pages/admin/AdminShareStats";
import AdminAudience from "@/pages/admin/AdminAudience";
import AdminAICosts from "@/pages/admin/AdminAICosts";
import AdminFounders from "@/pages/admin/AdminFounders";
import ProLoyalty from "@/pages/pro/ProLoyalty";
import ProCrmContacts from "@/pages/pro/ProCrmContacts";
import ProCrmCampaigns from "@/pages/pro/ProCrmCampaigns";
import ProCrmSettings from "@/pages/pro/ProCrmSettings";
import VipSignup from "@/pages/VipSignup";
import CrmConfirm from "@/pages/CrmConfirm";
import MentionsLegales from "@/pages/legal/MentionsLegales";
import Confidentialite from "@/pages/legal/Confidentialite";
import CookiesPage from "@/pages/legal/Cookies";
import CGV from "@/pages/legal/CGV";
import CGU from "@/pages/legal/CGU";
import AccountPrivacy from "@/pages/account/AccountPrivacy";
import MyAnnonces from "@/pages/account/MyAnnonces";
import MessagesInbox from "@/pages/account/MessagesInbox";
import PaymentResult from "@/pages/annonces/PaymentResult";
import AnnoncesList from "@/pages/annonces/AnnoncesList";
import AnnonceDetail from "@/pages/annonces/AnnonceDetail";
import AnnonceForm from "@/pages/annonces/AnnonceForm";
import ProposeEvent from "@/pages/ProposeEvent";
import AssociationsLocales from "@/pages/AssociationsLocales";
import AnnonceRules from "@/pages/annonces/AnnonceRules";
import AdminAnnonces from "@/pages/admin/AdminAnnonces";
import QuoteRequest from "@/pages/devis/QuoteRequest";
import QuoteTracking from "@/pages/devis/QuoteTracking";
import ProQuoteRequests from "@/pages/pro/ProQuoteRequests";
import ProQuoteProfile from "@/pages/pro/ProQuoteProfile";
import ProOpportunities from "@/pages/pro/ProOpportunities";
import MyQuotes from "@/pages/account/MyQuotes";
import AdminQuotes from "@/pages/admin/AdminQuotes";
import AdminEmails from "@/pages/admin/AdminEmails";
import AdminCartes from "@/pages/admin/AdminCartes";
import CartesLayout from "@/pages/cartes/CartesLayout";
import MesCartes from "@/pages/cartes/MesCartes";
import NouvelleCarte from "@/pages/cartes/NouvelleCarte";
import EditeurCarte from "@/pages/cartes/EditeurCarte";
import StatsCarte from "@/pages/cartes/StatsCarte";
import CartePublique from "@/pages/cartes/CartePublique";
import CarteVisiteLanding from "@/pages/cartes/CarteVisiteLanding";
import InstallPWABanner from "@/components/InstallPWABanner";
import MobileTabBar from "@/components/MobileTabBar";
import AdminSiteAlert from "@/components/AdminSiteAlert";
import ImpersonationBanner from "@/components/ImpersonationBanner";
import SiteTheme from "@/components/SiteTheme";

function Protected({ roles }) {
  const { user } = useAuth();
  if (user === null) return <div className="p-10 text-center text-slate-500">Chargement…</div>;
  if (user === false) return <Navigate to="/connexion" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return <Outlet />;
}

function App() {
  return (
    <div className="App pb-16 lg:pb-0">
      <AuthProvider>
        <BrowserRouter>
          <SiteTheme />
          <Toaster richColors position="top-right" />
          <ImpersonationBanner />
          <InstallPWABanner />
          <MobileTabBar />
          <AdminSiteAlert />
          <Routes>
            <Route path="/vip/:id" element={<VipSignup />} />
            <Route path="/crm/confirmer/:token" element={<CrmConfirm />} />
            <Route path="/carte/:slug" element={<CartePublique />} />
            <Route element={<PublicLayout />}>
              <Route path="/" element={<RouteOverride route="/" fallback={<Home />} />} />
              <Route path="/bons-plans" element={<RouteOverride route="/bons-plans" fallback={<Deals />} />} />
              <Route path="/partenaires" element={<RouteOverride route="/partenaires" fallback={<Partners />} />} />
              <Route path="/bons-plans/:categorySlug" element={<Deals />} />
              <Route path="/offre/:id" element={<OfferDetail />} />
              <Route path="/commerce/:id" element={<BusinessDetail />} />
              <Route path="/categories" element={<Categories />} />
              <Route path="/categories/:slug" element={<CategoryDetail />} />
              <Route path="/categories/:slug/:subslug" element={<CategoryDetail />} />
              <Route path="/villes" element={<Cities />} />
              <Route path="/a-propos" element={<RouteOverride route="/a-propos" fallback={<About />} />} />
              <Route path="/guides" element={<Guides />} />
              <Route path="/guide-pratique" element={<GuidePratique />} />
              <Route path="/guides/:slug" element={<GuideArticle />} />
              <Route path="/devenir-partenaire" element={<BecomePartner />} />
              <Route path="/devenir-partenaire/inscription/:planKey" element={<PartnerSignup />} />
              <Route path="/offre-fondateurs" element={<FounderOffer />} />
              <Route path="/club/:code" element={<ClubLanding />} />
              <Route path="/pour-les-cse" element={<LandingCSE />} />
              <Route path="/pour-les-professionnels" element={<ProsLanding />} />
              <Route path="/recevoir-des-devis" element={<ProReceiveQuotes />} />
              <Route path="/avis" element={<AvisHub />} />
              <Route path="/avis/:seg1" element={<AvisHub />} />
              <Route path="/avis/:seg1/:seg2" element={<AvisHub />} />
              <Route path="/reseau-pro" element={<NetworkPublic />} />
              <Route path="/reseau-pro/:category" element={<NetworkSector />} />
              <Route path="/reseau-pro/:category/:city" element={<NetworkSector />} />
              <Route path="/pour-les-associations" element={<AssociationsLanding />} />
              <Route path="/pole/:poleId" element={<PolePage />} />
              <Route path="/bons-plans/ville/:citySlug" element={<CityPage />} />
              <Route path="/carte" element={<MapPage />} />
              <Route path="/carte-de-visite-digitale" element={<CarteVisiteLanding />} />
              <Route path="/recommander-un-commerce" element={<RecommendPartner />} />
              <Route path="/autour-de-moi" element={<AroundMe />} />
              <Route path="/sortir" element={<EventsPage />} />
              <Route path="/sortir/:slug" element={<EventDetail />} />
              <Route path="/groupes-facebook" element={<FacebookGroups />} />
              <Route path="/organismes-collectivites" element={<OrganismePresentation />} />
              <Route path="/organismes-collectivites/inscription" element={<OrganismeRegister />} />
              <Route path="/rejoindre/:orgId" element={<JoinOrganization />} />
              <Route path="/rejoindre-asso/:aid" element={<JoinAssociation />} />
              <Route path="/associations" element={<Associations />} />
              <Route path="/associations/inscription" element={<AssociationRegister />} />
              <Route path="/associations/:slug" element={<AssociationDetail />} />
              <Route path="/associations/:slug/actualites/:newsSlug" element={<AssociationNews />} />
              <Route path="/clubs" element={<Clubs />} />
              <Route path="/clubs/inscription" element={<ClubRegister />} />
              <Route path="/clubs/:slug" element={<ClubDetail />} />
              <Route path="/clubs/:slug/actualites/:newsSlug" element={<ClubNewsPublic />} />
              <Route path="/rejoindre-club/:aid" element={<JoinClub />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/suggestions" element={<Suggestions />} />
              <Route path="/connexion" element={<Login />} />
              <Route path="/auth/google" element={<GoogleCallback />} />
              <Route path="/bienvenue-google" element={<WelcomeGoogle />} />
              <Route path="/inscription" element={<Register />} />
              <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
              <Route path="/mot-de-passe-reinitialiser" element={<ResetPassword />} />
              <Route path="/mentions-legales" element={<MentionsLegales />} />
              <Route path="/confidentialite" element={<Confidentialite />} />
              <Route path="/cookies" element={<CookiesPage />} />
              <Route path="/cgv" element={<CGV />} />
              <Route path="/cgu" element={<CGU />} />
              <Route path="/paiement/succes" element={<PaymentSuccess />} />
              <Route path="/paiement/annule" element={<PaymentCancel />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogArticle />} />
              <Route path="/actu" element={<PressReview />} />
              <Route path="/actu/:slug" element={<PressArticle />} />
              <Route path="/revues-de-presse" element={<RevuePresseList />} />
              <Route path="/revue-presse/:slug" element={<RevuePresse />} />
              <Route path="/actu-3/:slug" element={<PressTrio />} />
              <Route path="/entre-voisins" element={<EntreVoisins />} />
              <Route path="/entre-voisins/:id" element={<EntreVoisinsDetail />} />
              <Route path="/voisin/:userId" element={<NeighborProfile />} />
              <Route path="/petites-annonces" element={<AnnoncesList />} />
              <Route path="/petites-annonces/regles" element={<AnnonceRules />} />
              <Route path="/petites-annonces/deposer" element={<AnnonceForm />} />
              <Route path="/petites-annonces/categorie/:slug" element={<AnnoncesList />} />
              <Route path="/petites-annonces/annonce/:slug" element={<AnnonceDetail />} />
              <Route path="/p/:slug" element={<CmsPage />} />
              <Route path="/fiches-google" element={<GoogleListings />} />
              <Route path="/demande-de-devis" element={<QuoteRequest />} />
              <Route path="/demande-de-devis/:tradeSlug" element={<QuoteRequest />} />
              <Route path="/suivi-devis/:token" element={<QuoteTracking />} />
              {/* Catch-all SEO : /restaurants-chartres, /artisans-chartres... — en DERNIER des routes publiques */}
              <Route path="/:combinedSlug" element={<CategoryCityPage />} />
            </Route>

            <Route element={<Protected roles={["particular", "member", "professional", "admin", "super_admin"]} />}>
              <Route element={<AccountLayout />}>
                <Route path="/compte" element={<AccountProfile />} />
                <Route path="/compte/favoris" element={<Favorites />} />
                <Route path="/compte/mes-annonces" element={<MyAnnonces />} />
                <Route path="/compte/mes-devis" element={<MyQuotes />} />
                <Route path="/compte/messages" element={<MessagesInbox />} />
                <Route path="/compte/confidentialite" element={<AccountPrivacy />} />
                <Route path="/compte/assistant-ia" element={<AiAgent />} />
                <Route path="/compte/publier-facebook" element={<ProFbPosts />} />
                <Route path="/compte/partager-entre-voisins" element={<ProVoisinShare />} />
                <Route path="/compte/partager-article" element={<ProBlogShare />} />
                <Route path="/compte/partager-actualite" element={<ProPressShare />} />
                <Route path="/compte/partager-evenement" element={<ProEventShare />} />
              </Route>
            </Route>

            <Route element={<Protected roles={["particular", "member", "professional", "association", "club", "organization", "admin", "super_admin"]} />}>
              <Route element={<PublicLayout />}>
                <Route element={<CartesLayout />}>
                  <Route path="/ma-carte" element={<MesCartes />} />
                  <Route path="/ma-carte/nouvelle" element={<NouvelleCarte />} />
                  <Route path="/ma-carte/:id/editer" element={<EditeurCarte />} />
                  <Route path="/ma-carte/:id/stats" element={<StatsCarte />} />
                </Route>
              </Route>
            </Route>

            <Route element={<Protected roles={["particular", "professional", "association", "club", "organization", "member", "admin", "super_admin"]} />}>
              <Route path="/ia" element={<AiAgentStandalone />} />
            </Route>

            <Route element={<Protected roles={["particular", "professional", "association", "club", "organization", "member", "admin", "super_admin"]} />}>
              <Route element={<PublicLayout />}>
                <Route path="/mon-assistant-ia" element={<AiAgent />} />
                <Route path="/proposer-un-evenement" element={<ProposeEvent />} />
              </Route>
            </Route>
            <Route element={<PublicLayout />}>
              <Route path="/associations-helloasso" element={<AssociationsLocales />} />
              <Route path="/petites-annonces/modifier/:id" element={<AnnonceForm />} />
              <Route path="/payment/success" element={<PaymentResult />} />
              <Route path="/payment/cancel" element={<PaymentResult />} />
            </Route>

            <Route element={<Protected roles={["professional", "club", "association", "organization"]} />}>
              <Route element={<NetworkLayout />}>
                <Route path="/reseau" element={<ProNetworkDirectory />} />
                <Route path="/reseau/connexions" element={<ProNetworkConnections />} />
                <Route path="/reseau/annonces" element={<ProNetworkListings />} />
                <Route path="/reseau/messages" element={<ProNetworkMessages />} />
                <Route path="/reseau/profil" element={<ProNetworkProfile />} />
              </Route>
            </Route>

            <Route element={<Protected roles={["professional"]} />}>
              <Route element={<ProLayout />}>
                <Route path="/pro" element={<ProDashboard />} />
                <Route path="/pro/entreprise" element={<ProBusiness />} />
                <Route path="/pro/offres" element={<ProOffers />} />
                <Route path="/pro/statistiques" element={<ProStats />} />
                <Route path="/pro/offres/nouvelle" element={<ProOfferForm />} />
                <Route path="/pro/offres/:id/editer" element={<ProOfferForm />} />
                <Route path="/pro/abonnement" element={<ProSubscription />} />
                <Route path="/pro/factures" element={<ProInvoices />} />
                <Route path="/pro/support" element={<ProSupport />} />
                <Route path="/pro/publications-facebook" element={<ProFbPosts />} />
                <Route path="/pro/scanner" element={<ProScanner />} />
                <Route path="/pro/avis" element={<ProReviews />} />
                <Route path="/pro/reputation" element={<ProReputation />} />
                <Route path="/pro/fidelite" element={<ProLoyalty />} />
                <Route path="/pro/clients" element={<ProCrmContacts />} />
                <Route path="/pro/clients/campagnes" element={<ProCrmCampaigns />} />
                <Route path="/pro/clients/collecte" element={<ProCrmSettings />} />
                <Route path="/pro/aide" element={<ProHelp />} />
                <Route path="/pro/partager-evenement" element={<ProEventShare />} />
                <Route path="/pro/partager-article" element={<ProBlogShare />} />
                <Route path="/pro/partager-actualite" element={<ProPressShare />} />
                <Route path="/pro/partager-entre-voisins" element={<ProVoisinShare />} />
                <Route path="/pro/assistant-ia" element={<AiAgent />} />
                <Route path="/pro/demandes-devis" element={<ProQuoteRequests />} />
                <Route path="/pro/opportunites" element={<ProOpportunities />} />
                <Route path="/pro/demandes-devis/profil" element={<ProQuoteProfile />} />
              </Route>
            </Route>

            <Route element={<Protected roles={["organization"]} />}>
              <Route element={<OrgLayout />}>
                <Route path="/organisme" element={<OrgDashboard />} />
                <Route path="/organisme/profil" element={<OrgProfile />} />
                <Route path="/organisme/membres" element={<OrgMembers />} />
                <Route path="/organisme/publications-facebook" element={<ProFbPosts />} />
                <Route path="/organisme/partager-evenement" element={<ProEventShare />} />
                <Route path="/organisme/partager-article" element={<ProBlogShare />} />
                <Route path="/organisme/partager-actualite" element={<ProPressShare />} />
                <Route path="/organisme/partager-entre-voisins" element={<ProVoisinShare />} />
                <Route path="/organisme/assistant-ia" element={<AiAgent />} />
              </Route>
            </Route>

            <Route element={<Protected roles={["association"]} />}>
              <Route element={<AssocLayout />}>
                <Route path="/espace-association" element={<AssocDashboard />} />
                <Route path="/espace-association/profil" element={<AssocProfile />} />
                <Route path="/espace-association/evenements" element={<AssocEvents />} />
                <Route path="/espace-association/actualites" element={<AssocNews />} />
                <Route path="/espace-association/membres" element={<AssocMembers />} />
                <Route path="/espace-association/dons" element={<AssocDonations />} />
                <Route path="/espace-association/documents" element={<AssocDocuments />} />
                <Route path="/espace-association/ressources" element={<AssocResources />} />
                <Route path="/espace-association/publications-facebook" element={<ProFbPosts />} />
                <Route path="/espace-association/partager-evenement" element={<ProEventShare />} />
                <Route path="/espace-association/partager-article" element={<ProBlogShare />} />
                <Route path="/espace-association/partager-actualite" element={<ProPressShare />} />
                <Route path="/espace-association/partager-entre-voisins" element={<ProVoisinShare />} />
                <Route path="/espace-association/assistant-ia" element={<AiAgent />} />
              </Route>
            </Route>

            <Route element={<Protected roles={["club"]} />}>
              <Route element={<ClubLayout />}>
                <Route path="/espace-club" element={<ClubDashboard />} />
                <Route path="/espace-club/profil" element={<ClubProfile />} />
                <Route path="/espace-club/evenements" element={<ClubEvents />} />
                <Route path="/espace-club/actualites" element={<ClubNews />} />
                <Route path="/espace-club/membres" element={<ClubMembers />} />
                <Route path="/espace-club/dons" element={<ClubDonations />} />
                <Route path="/espace-club/documents" element={<ClubDocuments />} />
                <Route path="/espace-club/ressources" element={<ClubResources />} />
                <Route path="/espace-club/publications-facebook" element={<ProFbPosts />} />
                <Route path="/espace-club/partager-evenement" element={<ProEventShare />} />
                <Route path="/espace-club/partager-article" element={<ProBlogShare />} />
                <Route path="/espace-club/partager-actualite" element={<ProPressShare />} />
                <Route path="/espace-club/partager-entre-voisins" element={<ProVoisinShare />} />
                <Route path="/espace-club/assistant-ia" element={<AiAgent />} />
              </Route>
            </Route>

            <Route element={<Protected roles={["member", "particular"]} />}>
              <Route element={<MemberLayout />}>
                <Route path="/mon-pass" element={<MemberPass />} />
                <Route path="/mes-recompenses" element={<MemberRewards />} />
                <Route path="/partager-article" element={<ProBlogShare />} />
                <Route path="/partager-actualite" element={<ProPressShare />} />
                <Route path="/partager-evenement" element={<ProEventShare />} />
                <Route path="/partager-entre-voisins" element={<ProVoisinShare />} />
                <Route path="/publier-facebook" element={<ProFbPosts />} />
              </Route>
            </Route>

            <Route element={<Protected roles={["admin", "super_admin"]} />}>
              <Route element={<AdminLayout />}>
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/admin/utilisateurs" element={<AdminUsers />} />
                <Route path="/admin/professionnels" element={<AdminPros />} />
                <Route path="/admin/offres" element={<AdminOffers />} />
                <Route path="/admin/offres/nouvelle" element={<AdminCreateOffer />} />
                <Route path="/admin/offres/:id/editer" element={<AdminOfferForm />} />
                <Route path="/admin/professionnels/nouveau" element={<AdminCreatePro />} />
                <Route path="/admin/categories" element={<AdminCategories />} />
                <Route path="/admin/villes" element={<AdminCities />} />
                <Route path="/admin/demandes" element={<AdminRequests />} />
                <Route path="/admin/codes" element={<AdminCodes />} />
                <Route path="/admin/import" element={<AdminImportBeneficiaries />} />
                <Route path="/admin/journal" element={<AdminJournal />} />
                <Route path="/admin/audience" element={<AdminAudience />} />
                <Route path="/admin/journal-emails" element={<AdminEmailLogs />} />
                <Route path="/admin/clubs" element={<AdminClubs />} />
                <Route path="/admin/blog" element={<AdminBlog />} />
                <Route path="/admin/revue-presse" element={<AdminPressReview />} />
                <Route path="/admin/revue-presse-3-art" element={<AdminPressReview3Art />} />
                <Route path="/admin/revues-de-presse" element={<AdminRevuePresse />} />
                <Route path="/admin/entre-voisins" element={<AdminEntreVoisins />} />
                <Route path="/admin/devis" element={<AdminQuotes />} />
                <Route path="/admin/editeur-site" element={<AdminSiteBuilder />} />
                <Route path="/admin/statistiques-partage" element={<AdminShareStats />} />
                <Route path="/admin/couts-ia" element={<AdminAICosts />} />
                <Route path="/admin/campagne-fondateur" element={<AdminFounders />} />
                <Route path="/admin/parametres" element={<AdminSettings />} />
                <Route path="/admin/partenaires-inscriptions" element={<AdminPartnerSignups />} />
                <Route path="/admin/formules-partenaires" element={<AdminPartnerConfig />} />
                <Route path="/admin/reseaux-sociaux" element={<AdminSocialStudio />} />
                <Route path="/admin/studio-ia" element={<AdminAIStudio />} />
                <Route path="/admin/groupes-facebook" element={<AdminFacebookGroups />} />
                <Route path="/admin/publications-facebook" element={<AdminFbPosts />} />
                <Route path="/admin/publications-offres" element={<AdminOfferShare />} />
                <Route path="/admin/publications-evenements" element={<AdminEventShare />} />
                <Route path="/admin/portee-reseaux" element={<AdminSocialReach />} />
                <Route path="/admin/publications-facebook/:id" element={<AdminFbPostShare />} />
                <Route path="/admin/organismes" element={<AdminOrganizations />} />
                <Route path="/admin/associations" element={<AdminAssociations />} />
                <Route path="/admin/espace-clubs" element={<AdminEspaceClubs />} />
                <Route path="/admin/avis" element={<AdminReviews />} />
                <Route path="/admin/support" element={<AdminSupport />} />
                <Route path="/admin/signalements" element={<AdminOfferReports />} />
                <Route path="/admin/recommandations" element={<AdminPartnerRecommendations />} />
                <Route path="/admin/evenements" element={<AdminEvents />} />
                <Route path="/admin/petites-annonces" element={<AdminAnnonces />} />
                <Route path="/admin/relances-fiche" element={<AdminFicheReminders />} />
                <Route path="/admin/relances-clubs-assos" element={<AdminEntityReminders />} />
                <Route path="/admin/fiches-partenaires" element={<AdminPartnerFiches />} />
                <Route path="/admin/notifications" element={<AdminPushNotifications />} />
                <Route path="/admin/emails" element={<AdminEmails />} />
                <Route path="/admin/cartes" element={<AdminCartes />} />
              </Route>
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
